import React, { useState } from "react";
import {
  Avatar,
  IconButton,
  Menu,
  MenuItem,
  TableCell,
  ListItemAvatar,
  ListItemText,
} from "@mui/material";

import PersonOutlineIcon from "@mui/icons-material/PersonOutline";

const findUserByPickedBy = (pickedBy, availableUsers = []) => {
  if (!pickedBy) return null;

  return availableUsers.find(
    (u) =>
      u.username?.toLowerCase() === pickedBy.toLowerCase() ||
      u.userId === pickedBy
  );
};

const getInitials = (value) => {

  if (!value) return "";

  if (!value.includes("@")) {
    return value;
  }

  return value
    .split("@")[0]
    .split(/[.\-_]/)
    .map((x) => x[0]?.toUpperCase())
    .join(" ");
};

const PickedByCell = ({
  row,
  availableUsers = [],
  updateField,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  if (!row.stockInfo) {
    return <TableCell />;
  }

  const pickedBy = row.stockInfo?.pickedBy;
  const user = findUserByPickedBy(
    pickedBy,
    availableUsers
  );

  const handleSelect = (user) => {
    updateField(
      "stockInfo.pickedBy",
      user.username,
      {
        rowId: row.id,
      }
    );

    setAnchorEl(null);
  };

  return (
    <TableCell>
      <IconButton
        size="small"
        onClick={(e) =>
          setAnchorEl(e.currentTarget)
        }
      >
        {!pickedBy ? (
          <Avatar
            sx={{
              width: 28,
              height: 28,
              fontSize: 10,
              opacity: 0.5,
              border: "1px dashed",
            }}
          >
            <PersonOutlineIcon fontSize="small" />
          </Avatar>
        ) : user ? (
          <Avatar
            /*src={user.avatarUrl}*/
              title={getInitials(user.username)}
            sx={{
              width: 28,
              height: 28,
              fontSize: 10,
            }}
          >
              {getInitials(user.username)}
          </Avatar>
        ) : (
              <Avatar
                title={pickedBy}
                sx={{
                  width: 28,
                  height: 28,
                  fontSize: 10,
                }}
              >
                {pickedBy}
              </Avatar>
            )}
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        {availableUsers.map((user) => (
          <MenuItem
            key={user.userId}
            onClick={() => handleSelect(user)}
          >
            <ListItemAvatar>
              <Avatar
                src={user.avatarUrl}
                sx={{
                  width: 28,
                  height: 28,
                }}
              />
            </ListItemAvatar>

            <ListItemText
              primary={user.name}
              secondary={user.username}
            />
          </MenuItem>
        ))}
      </Menu>
    </TableCell>
  );
};

export default PickedByCell;